import { render } from "./ManualAttachCard.vue?vue&type=template&id=08d07dc6&scoped=true&ts=true"
import script from "./ManualAttachCard.vue?vue&type=script&lang=ts"
export * from "./ManualAttachCard.vue?vue&type=script&lang=ts"

import "./ManualAttachCard.vue?vue&type=style&index=0&id=08d07dc6&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d07dc6"]])

export default __exports__